import { call, CallEffect, PutEffect } from 'redux-saga/effects'

import { AxiosResponse } from 'axios'
import { Action } from 'redux-saga'
import { automaticApi } from '@/settings/api';

export interface Fetch {
    typeId: string;
    modelId: string;
    brandId: string;
    callback: (success: boolean, errorMessage?: string | unknown) => void;
}

export interface RequestCategoriesAction {
    type: string;
    payload: Fetch;
}


const uri = '/dominios/v1/veiculo/categorias'

export default function* requestCategories({
    payload,
}: RequestCategoriesAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {

        const body = {
            tipo: payload.typeId,
            marca: payload.brandId,
            modelo: payload.modelId,
        }

        const response: AxiosResponse = yield call(
            automaticApi.post,
            uri,
            body,
        );

        if (response?.data?.dados?.categorias?.length > 0) {
            const categories = response?.data?.dados?.categorias;
            const formattedCategories = categories.map((item: { descricao: string; id: string; }) => ({
                text: item.descricao,
                value: item.id,
                ...item,
            }))
            yield call(payload.callback, true, formattedCategories);
        } else {
            yield call(payload.callback, false);
        }
    } catch (error) {
        yield call(payload.callback, false);
    }
}
